<template>
    <div v-if="isShowModal" class="modal" >
        <div class="modal-overflow" @click="hide"></div>
        <div class="modal-box">

            <div class="modal-content">
                <div class="modal-title">{{ title }}</div>
                <div class="modal-body">
                    <div class="help-block" v-html="helpText"></div>
                    
                    
                </div>
                <div class="modal-bottom">
                    <mt-radio
                        v-model="checkedValue"
                        :options="options">
                        </mt-radio>
                    <div class="modal-btn" @click="btnClick">{{btnText}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
    props:{
        title:{
            type: String,
            default: ''
        },
        helpText:{
            type: String,
            default: ''
        },
        btnText:{
            type: String,
            default: ''
        },
        isShow:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            isShowModal: false,
            checkedValue: 0,
            options:[
                {
                    label:"我已阅读并同意",
                    value:1
                }
            ]
        }
    },
    watch:{
        isShow:{
            handler: function(newValue, oldValue){
                console.log(newValue)
                this.isShowModal = newValue
            },
            deep: true
        }
    },
    methods:{
        show(){
            this.isShowModal = true;
        },
        hide(){
            this.isShowModal = false;
            this.$emit("changeState", this.isShowModal)
        },
        btnClick(){
            if(this.checkedValue != 1){
                Toast("请勾选并同意协议")
            }else{
                this.hide();
            }
        }
    }
}
</script>

<style scoped>
    .modal{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
    }
    .modal-overflow{
        opacity: 0.8;
        background: #263548;
        width: 100%;
        height: 100%;
    }
    .modal-box{
        position: absolute;
        top: 15%;
        left: 10%;
        width: 80%;

        background: #fff;
        height: 70%;
        border-radius: 8px;

        display: flex;
    }
    .modal-content{
        text-align: center;
        padding-top:20px;
        padding-bottom: 20px;
        width: 100%;
    }
    .modal-title{
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #263548;
        line-height: 21px;
    }
    .modal-body {
        margin-top: 10px;
        height: 70%;
        padding: 0 20px;
        overflow: auto;
    }
    .modal-body img{
        display: inline-block;
        width: 100%;
        height: auto;
    }
    .help-block{
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #8A8E94;
        margin-top: 10px;
        text-align: left;
    }
    .modal-bottom{
        padding: 0 40px;
    }
    .modal-btn{
        background: #EF5B3D;
        border-radius: 18px;
        width: 100%;
        margin-top: 6px;
        height: 36px;
        line-height: 36px;
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #FFFFFF;
    }
    .modal-btn:active,.close-btn:active{
        opacity: 0.8;
    }
    .close-btn img{
        width: 32px;
        height: 62px;
    }
    .close-btn{
         position: absolute;
         bottom: 0px;
         top: -62px;
         right: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/NoticeModal.vue